// Shared copy + docs link for the "Select the type of control plane." step.
// Used by both ClusterArchitectureFieldsOpenStack and ClusterArchitectureFieldsBYO
// so the two cards stay identical on the OpenStack and BYO paths.

// NOTE: confirm the exact published base path in a browser after the docs PR merges.
// GitBook may serve it versioned (e.g. .../2026.4/kubernetes-clusters/control-plane-types)
// or unversioned. Update this single constant if the path changes.
export const CONTROL_PLANE_TYPES_DOCS_URL =
  'https://docs.platform9.com/private-cloud-director/kubernetes-clusters/control-plane-types'

export const CONTROL_PLANE_TYPES_DOCS_LINK_TEXT = 'Learn about control plane types'

export const managedControlPlaneCard = {
  description: 'Hosted on PCD management plane',
  info:
    "Runs as a managed service on PCD's management plane - your compute infrastructure stays " +
    'available for worker nodes.',
}

export const colocatedControlPlaneCard = {
  description: 'Hosted on your own infrastructure',
  info: 'Each cluster gets its own dedicated, isolated control plane.',
}
